import Model  from '@/utils/models';

export default class Admin extends Model { 
    backend = '/rbac/'; 

    uploadImage(formdata, params={}){
        return this.api.post(this.backend + 'user/upload-image', formdata, params, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }

    profileUpdate(body, params){
        return this.api.put(this.backend + 'user/profile-update', body, params); 
    }

    profileIndex(params={}){
        return this.api.get(this.backend + 'user/profile-index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    all(params = {}){
        return this.api.get(this.backend + 'user/index', params).then(res => {
            return res.status == 200 ? res.data : {};
        });
    }

    create(body){
        return this.api.post(this.backend + 'user/create', body);
    }

    update(body, params){
        return this.api.put(this.backend + 'user/update', body, params); 
    }

    view(params={}){
        return this.api.get(this.backend + 'user/view', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    assignment(params){
        return this.api.get(this.backend + 'assignment/view', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    assign(body, params={}){
        return this.api.post(this.backend + 'assignment/assign', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    revoke(body, params={}){
        return this.api.post(this.backend + 'assignment/revoke', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    routes(params={}){
        return this.api.get(this.backend + 'route/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    addRoutes(body){
        return this.api.post(this.backend + 'route/assign', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    removeRoutes(body){
        return this.api.post(this.backend + 'route/remove', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    role(params={}){
        return this.api.get(this.backend + 'role/view', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    roles(params={}){
        return this.api.get(this.backend + 'role/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    addRole(body){
        return this.api.post(this.backend + 'role/create', body);
    }

    deleteRole(params){
        return this.api.delete(this.backend + 'role/delete', params);
    }

    roleAssign(body, params){
        return this.api.post(this.backend + 'role/assign', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    roleRevoke(body, params){
        return this.api.post(this.backend + 'role/remove', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    permission(params={}){
        return this.api.get(this.backend + 'permission/view', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    permissions(params={}){
        return this.api.get(this.backend + 'permission/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    addPermission(body){
        return this.api.post(this.backend + 'permission/create', body);
    }

    deletePermission(params){
        return this.api.delete(this.backend + 'permission/delete', params);
    }

    permissionAssign(body, params){
        return this.api.post(this.backend + 'permission/assign', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    permissionRevoke(body, params){
        return this.api.post(this.backend + 'permission/remove', body, params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }


    

    // office

    nodeAssignment(params){
        return this.api.get(this.backend + 'user/node-assignment', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    nodeAssign(body){
        return this.api.post(this.backend + 'user/node-assign', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    nodeRevoke(body){
        return this.api.post(this.backend + 'user/node-revoke', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    jilidAssignment(params){
        return this.api.get(this.backend + 'user/jilid-assignment', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    jilidAssign(body){
        return this.api.post(this.backend + 'user/jilid-assign', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    jilidRevoke(body){
        return this.api.post(this.backend + 'user/jilid-revoke', body).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    setPresent(body = {}, params = {}){
        return this.api.post(this.backend + 'user/set-present', body, params);
    }

    nodes(params={}){
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }
            
}

